import React, { useEffect, useState } from "react";
import LookingFor from "../looking-for-property/LookingFor";
import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/mainlogoNew.png";
import { useTranslation } from "react-i18next";
import {
  GetAllPropertyTyoes,
  GetPropertyCategoryByType,
} from "../../services/PostProperty";
import { useDispatch, useSelector } from "react-redux";
import SelectPropertyType from "../select-property/SelectPropertyType";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import VectorLogin from "../../assets/images/Vector 5 (1).png";
import {
  resolvePropertyTypeSlug,
  toPropertySelection,
} from "../../lib/propertySlug";
import { userDashboardSelector } from "../../redux/userDashboard";

const LookingForDialog = ({ open, onClose, location }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { allPropertyTypes } = useSelector(userDashboardSelector);
  const [selectPropType, setSelectPropType] = useState();
  const [userLookingForData, setUserLookingForData] = useState();
  const [propertyTypeData, setPropertyTypeData] = useState();
  const [showPropertyTypes, setShowPropertyTypes] = useState(false);

  const langauge = localStorage.getItem("language");
  const langParam = langauge === "pr" ? 2 : 1;
  const propertyTypes = allPropertyTypes?.items || [];

  const getAllPropertyTypesData = () => {
    dispatch(GetAllPropertyTyoes(langParam));
  };

  const getAllPropertyCategoryData = (propertyTypeSlug) => {
    dispatch(GetPropertyCategoryByType(langParam));
    return propertyTypeSlug;
  };

  useEffect(() => {
    getAllPropertyTypesData();
    if (location === "homepage") {
      setShowPropertyTypes(true);
    }
  }, [location]);

  useEffect(() => {
    if (location !== "homepage" || propertyTypes.length === 0) {
      return;
    }

    const preferredType =
      propertyTypes.find((item) => {
        const label = String(item?.property_type || item?.property_type_title || "").toLowerCase();
        return label.includes("sell") || label.includes("buy");
      }) || propertyTypes[0];

    const normalizedType = toPropertySelection(preferredType);
    setUserLookingForData(normalizedType);
    localStorage?.setItem("userLookingFor", JSON.stringify(normalizedType));
    getAllPropertyCategoryData(resolvePropertyTypeSlug(propertyTypes, normalizedType));
  }, [location, propertyTypes]);

  const handleSelectPropertyType = async (data) => {
    const normalizedType = toPropertySelection(data);
    setUserLookingForData(normalizedType);

    if (data) {
      await localStorage?.setItem("userLookingFor", JSON.stringify(normalizedType));
      await getAllPropertyCategoryData(resolvePropertyTypeSlug(propertyTypes, normalizedType));

      if (
        data?.property_type == "Buy Property" ||
        data?.property_type == "Rent a property"
      ) {
        setShowPropertyTypes(false);
        navigate("/buy-property", { state: data?.property_type });
      }

      setShowPropertyTypes(true);
    }
  };

  const handleSelectPropertyOptions = async (data) => {
    const normalizedType = toPropertySelection(data);
    setPropertyTypeData(normalizedType);

    if (data) {
      await localStorage?.setItem("propertyType", JSON.stringify(normalizedType));
      setShowPropertyTypes(true);
      if (userLookingForData?.property_type == "Buy Property") {
        navigate("/buy-property");
      } else {
        navigate("/post-property");
      }
    }
  };

  return (
    <Dialog
      maxWidth="md"
      open={open}
      className="filter-dialog-product-search"
      aria-labelledby="category-filter-dialog"
      sx={{
        "& .MuiDialog-paper": {
          width: "900px",
          maxWidth: "100%",
          borderRadius: "16px",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ p: 0, height: "600px", display: "flex", overflow: "hidden" }}>
        <Box className="auth-dialog">
          <Box className="auth-left">
            <Box sx={{ position: "relative", zIndex: 2, padding: "0 40px", marginTop: "-200px" }}>
              <Typography
                variant="h2"
                component="h4"
                sx={{
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: { xs: "24px", md: "32px" },
                  fontFamily: "Poppins",
                  lineHeight: 1.3,
                  margin: 0,
                  maxWidth: "280px",
                }}
              >
                {t("LogIn.BuySellText")} {" "}
                <Typography
                  component="span"
                  sx={{
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: { xs: "24px", md: "32px" },
                    fontFamily: "Poppins",
                    lineHeight: 1.3,
                    margin: 0,
                  }}
                >
                  {t("LogIn.FastestWay")}
                </Typography>
              </Typography>
            </Box>
            <Box
              component="img"
              src={VectorLogin}
              alt="vector design"
              sx={{
                position: "absolute",
                bottom: { xs: "-10px", md: "-30px" },
                left: "-20px",
                width: "120%",
                maxWidth: "400px",
                zIndex: 1,
                pointerEvents: "none",
              }}
            />
          </Box>

          <Box className="auth-right" sx={{ position: "relative", justifyContent: "center", padding: "40px" }}>
            <IconButton
              aria-label="close"
              sx={{
                position: "absolute",
                right: 16,
                top: 16,
                color: (theme) => theme.palette.grey[500],
              }}
              onClick={() => navigate("/my-property")}
            >
              <CloseIcon />
            </IconButton>

            <Box className="looking-for-property-type" sx={{ width: "100%", maxWidth: "400px", margin: "0 auto" }}>
              {location === "homepage" ? (
                <SelectPropertyType
                  handleSelectPropertyOptions={handleSelectPropertyOptions}
                  onClose={onClose}
                  PropertyCat={""}
                  setShowPropertyTypes={setShowPropertyTypes}
                />
              ) : (
                <>
                  {!showPropertyTypes && (
                    <LookingFor
                      handleSelectPropertyType={handleSelectPropertyType}
                      onClose={onClose}
                      PropType={selectPropType}
                    />
                  )}
                  {showPropertyTypes && (
                    <SelectPropertyType
                      handleSelectPropertyOptions={handleSelectPropertyOptions}
                      onClose={onClose}
                      PropertyCat={""}
                      setShowPropertyTypes={setShowPropertyTypes}
                    />
                  )}
                </>
              )}
            </Box>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LookingForDialog;
